import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  InputComponentRequirementDialogContext,
  InputComponentRequirementDialogInitialState,
} from "./";

export const InputComponentRequirementDialogStateProvider = ({
  children,
}: any) => {
  const [pageState, setPageState] = useState(
    InputComponentRequirementDialogInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <InputComponentRequirementDialogContext.Provider value={context}>
      {children}
    </InputComponentRequirementDialogContext.Provider>
  );
};
